import { WorkflowContext } from '@samelogic/steps';
import { contextFactory } from '../../../__tests__/factories';
import { ElementEventProps, ElementEventStrategy } from './ElementEventStrategy';
import { EventStrategyResolver, Strategies } from './EventStrategyResolver';
import { PageEventProps, PageEventStrategy } from './PageEventStrategy';

describe('EventStrategyResolver', () => {
  const resolver = new EventStrategyResolver();
  const context: WorkflowContext = contextFactory.build();
  let strategy: Strategies;
  describe('when event type is "element click"', () => {
    const props: ElementEventProps = {
      event: 'ElementClick',
      cssSelector: '.test'
    };
    beforeEach(() => {
      strategy = resolver.resolveStrategyByEventType(context, props);
    });
    it('should return ElementEventStrategy', () => {
      expect(strategy).toBeInstanceOf(ElementEventStrategy);
    });
  });

  describe('when event type is "element mouse over"', () => {
    const props: ElementEventProps = {
      event: 'ElementMouseOver',
      cssSelector: '.test'
    };
    beforeEach(() => {
      strategy = resolver.resolveStrategyByEventType(context, props);
    });
    it('should return ElementEventStrategy', () => {
      expect(strategy).toBeInstanceOf(ElementEventStrategy);
    });
  });

  describe('when event type is "page view"', () => {
    const props: PageEventProps = {
      event: 'PageView',
      urlPattern: ''
    };
    beforeEach(() => {
      strategy = resolver.resolveStrategyByEventType(context, props);
    });
    it('should return PageEventStrategy', () => {
      expect(strategy).toBeInstanceOf(PageEventStrategy);
    });
  });
});
